import type { CareerPageSettings } from '@recruitai/shared';
import { apiClient } from './api-client';

export interface CareerPageSettingsResponse {
  careerPage: CareerPageSettings;
  slug: string;
  publicUrl: string;
}

export const careerSettingsApi = {
  getSettings: () =>
    apiClient.get<CareerPageSettingsResponse>('/organizations/career-page'),

  updateSettings: (data: Partial<CareerPageSettings>) =>
    apiClient.patch<CareerPageSettings>('/organizations/career-page', data),

  updateSlug: (slug: string) =>
    apiClient.patch<{ slug: string }>('/organizations/slug', { slug }),
};
